// removed by extract-text-webpack-plugin
module.exports = {"marketing":"uxOEc","block":"_2PtCz","image":"_5g9Sk","title":"_3BYT9","paragraph":"qHnbm","footer":"_3qU1Y"};